import Splide from '@splidejs/splide';

export function createSplideOptions(element) {
  return {
    type: 'loop',
    autoplay: 'pause',
    direction: element.classList.contains('js-slider-reverse') ? 'rtl' : 'ltr',
    focus: 'center',
    arrows: false,
    pagination: true,
    drag: true,
    gap: '16px',
    padding: {
      left: '20px',
      right: '20px',
    },
    autoScroll: {
      speed: 1,
      pauseOnHover: false,
      pauseOnFocus: false,
    },
    mediaQuery: 'min',
    breakpoints: {
      360: {
        perPage: 1,
        fixedWidth: 320,
      },
      480: {
        fixedWidth: 420,
      },
      940: {
        fixedWidth: 900,
        gap: '40px',
      },
    },
  };
}

export default function mainVisualSlider() {
  const promiseTargets = {
    'js-inview': '-inview',
    'js-imageloaded': '-imageloaded',
  };
  const promiseTargetsKeys = Object.keys(promiseTargets);

  document.querySelectorAll('.js-MainVisualSlider').forEach((element) => {
    const slideNodeList = element.querySelectorAll('.splide__slide');

    if (slideNodeList.length < 2) return;

    const splideInstance = new Splide(element, createSplideOptions(element));

    splideInstance.mount();

    if (splideInstance.options.autoplay) {
      const targetElements = promiseTargetsKeys.map((className) =>
        element.closest(`.${className}`),
      );
      const invalidElements = targetElements.filter((el) => el === null);
      if (invalidElements.length > 0) {
        console.warn('Warning: Some target elements for autoplay are missing.', invalidElements);
      }
      splideInstance.Components.Autoplay.pause();

      const observer = new MutationObserver(() => {
        const allDone = targetElements.every((targetElement, index) => {
          if (!targetElement) return true;
          return targetElement.classList.contains(promiseTargets[promiseTargetsKeys[index]]);
        });
        if (allDone) {
          observer.disconnect();
          splideInstance.Components.Autoplay.play();
        }
      });

      targetElements.forEach((targetElement) => {
        if (targetElement) {
          observer.observe(targetElement, {
            attributes: true,
            attributeFilter: ['class'],
          });
        }
      });
    }
  });
}
